import { Session } from '../entity/entities';
import { PermissionsCatalogueEnum } from '../entity/enum/permissionsCatalogue';

/**
 * The caller's uClock permissions, read the same way on every uClock screen: an entry of
 * Session.userPermissions with Level 0 (visible). The server checks them too - this only keeps the
 * screens from offering what it would refuse.
 */
export class TlmPermissionHelper {
  public static has(permission: PermissionsCatalogueEnum): boolean {
    return !!(Session.userPermissions || []).find(
      (up: any) => up.FK_PermissionCatalogue == permission && up.Level == 0 /*visible*/
    );
  }

  /**
   * FENIKS US-9.2 (AC-6): changing the location's departments, jobs, house areas and department managers
   * is location-wide setup - "uClock Manage Departments". Without it the Departments and Jobs tabs are read-only.
   */
  public static canManageDepartments(): boolean {
    return TlmPermissionHelper.has(PermissionsCatalogueEnum.TlmManageDepartments);
  }
}
